import { useMutation } from "@/core/api/graphql/composables";
import { UpdateCustomerOrderIntendsToExportDocument } from "@/core/api/graphql/types";

export function useUpdateCustomerOrderIntendsToExportMutation() {
  return useMutation(UpdateCustomerOrderIntendsToExportDocument);
}
